module.exports = __webpack_public_path__ + "media/application/images/svgs/shield-off-2d06f85238f18a046f9180ff53de4cf1.svg";